import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[680px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20industry%20scene%20with%20dark%20atmospheric%20vibe%2C%20red%20carpet%20event%20with%20paparazzi%20camera%20flashes%2C%20crowd%20of%20people%20with%20smartphones%20recording%2C%20breaking%20news%20mood%2C%20cinematic%20lighting%20with%20warm%20orange%20and%20deep%20burgundy%20tones%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20abstract%20composition%20with%20bokeh%20lights%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20dark%20gradient%20background%2C%20paparazzi%20flash%20effects%2C%20luxurious%20event%20venue%20with%20velvet%20ropes&width=1920&height=900&seq=hero-main-bg-01&orientation=landscape"
          alt="51今日吃瓜网 - 全网最新吃瓜资源与爆料入口"
          title="51今日吃瓜网 - 全网最新吃瓜资源"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70"></div>

      <div className="relative z-10 h-full w-full flex items-center">
        <div className="mx-auto w-full max-w-[1280px] px-6 md:px-10">
          <div className="flex flex-col lg:flex-row items-start lg:items-end gap-8 lg:gap-16">
            <div className="flex-1 w-full">
              <div className="flex items-center gap-3 mb-6">
                <div className="flex -space-x-3">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white/60 overflow-hidden ring-2 ring-white/20">
                    <img
                      src="https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20casual%20portrait%2C%20neutral%20expression%2C%20simple%20dark%20background%2C%20social%20media%20avatar%20style%2C%20clean%20modern%20look%2C%20soft%20lighting&width=96&height=96&seq=hero-avatar-01&orientation=squarish"
                      alt="吃瓜用户"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white/60 overflow-hidden ring-2 ring-white/20">
                    <img
                      src="https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20casual%20portrait%2C%20friendly%20smile%2C%20simple%20dark%20background%2C%20social%20media%20avatar%20style%2C%20clean%20modern%20look%2C%20soft%20studio%20lighting&width=96&height=96&seq=hero-avatar-02&orientation=squarish"
                      alt="吃瓜用户"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white/60 overflow-hidden ring-2 ring-white/20">
                    <img
                      src="https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20casual%20portrait%2C%20cool%20expression%2C%20simple%20dark%20background%2C%20social%20media%20avatar%20style%2C%20clean%20modern%20look%2C%20soft%20lighting&width=96&height=96&seq=hero-avatar-03&orientation=squarish"
                      alt="吃瓜用户"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <span className="text-white/80 text-sm md:text-base font-medium whitespace-nowrap">100万+ 吃瓜群众正在追踪</span>
              </div>

              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6 max-w-2xl">
                <span className="font-light block">全网最新</span>
                吃瓜资源与爆料入口
              </h1>

              <Link
                to="/category/daily-contest"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-900 rounded-full text-sm md:text-base font-semibold hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap group"
              >
                进入每日大赛
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>

            <div className="lg:w-80 flex-shrink-0">
              <p className="text-white/60 text-sm md:text-base leading-relaxed">
                实时更新明星博主塌房现场、网红黑料、每日大赛等热门事件，聚合吃瓜视频和黑料追踪，吃瓜群众必看的信息集散地。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}